import { ValidationError } from "sequelize"
import {
    CcRequirementType,
    CcRequirementTypeCreate,
    CcRequirementTypeSave,
} from "server/models"
import { OrderType } from "client/utils"
import {
    GET, POST, DELETE, sort, validate, search,
} from "client/store/utils"
import { LangType } from "client/store"
import {
    CcRequirementTypeList,
    CcRequirementTypeFilters,
    CcRequirementTypeValidation,
} from "./types"


export const GetDefaultType = (
    typeList: CcRequirementTypeList,
    typeIds: readonly number[],
) => {
    let defaultType: CcRequirementType = null
    typeIds.forEach((id) => {
        const type = typeList[id]
        if (type.default) defaultType = type
    })

    if (!defaultType && typeIds.length) defaultType = typeList[typeIds[0]]
    return defaultType
}

export const LoadCcRequirementTypes = (
    accountId: number,
    projectId: number,
) => (
    GET(`/ccRequirementType/accountId/${accountId}/projectId/${projectId}`)
    .then((types: CcRequirementType[]) => {
        const typeList: CcRequirementTypeList = {}
        types.forEach((type) => {
            typeList[type.id] = type
        })
        return typeList
    })
)

export const LoadCcRequirementTypeById = (
    typeId: number,
    accountId: number,
    projectId: number,
) => (
    GET(`/ccRequirementType/id/${typeId}/accountId/${accountId}/projectId/${projectId}`)
    .then((method: CcRequirementType) => method)
)

export const SaveCcRequirementType = (
    id: number,
    type: CcRequirementTypeCreate,
    lang: LangType,
) => {
    const data: CcRequirementTypeSave = {
        id,
        type,
    }
    return POST(
        "/ccRequirementType/save",
        JSON.stringify(data),
    ).then((res) => {
        const newType = res as CcRequirementType
        const error = res as ValidationError
        return {
            newTypeId: newType.id || null,
            validation: <CcRequirementTypeValidation>validate(error, lang),
        }
    })
}

export const DeleteCcRequirementType = (typeId: number) => (
    DELETE(`/ccRequirementType/delete/${typeId}`)
    .then((removedRows: number) => removedRows)
)

export const CopyDefaultCcRequirementTypes = (
    accountId: number,
    projectId: number,
    defaultTypesAssigned: boolean,
) => (
    GET(`/ccRequirementType/copyDefault/accountId/${accountId}/projectId/${projectId}/${defaultTypesAssigned}`)
    .then((success: boolean) => success)
)

export const SortCcRequirementTypes = (
    types: CcRequirementType[],
    sortColumn: keyof CcRequirementType,
    sortOrder: OrderType,
    filters: CcRequirementTypeFilters,
) => {
    const typesFiltered = types.filter((type) => {
        let showRow = true
        if (filters.search) showRow = search(filters.search, type)
        return showRow
    })
    typesFiltered.sort((a, b) => sort(a, b, sortColumn, sortOrder))

    const typeIds: number[] = []
    typesFiltered.forEach((type) => typeIds.push(type.id))

    return typeIds
}
